import { calcHash } from '../../../../../../libs/file';
import { AddIntakePhotosInfo } from '../../../../../../types';
import { QueuedIntakeFileInfo } from '../../../../../../store/uploadStore';

export const generateCreatePayloadPhotosObject = (files: QueuedIntakeFileInfo[]) => {
  return files.reduce((acc, { name, size, fileCategory, file }) => {
    const hash = calcHash(file);

    acc[hash] = {
      name,
      fileCategory,
      size,
    };

    return acc;
  }, {} as AddIntakePhotosInfo);
};
